import {
  type ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveAmRole,
  type ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveTradeCompanyType,
  type AssignedAccountManagerListItem,
  useApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve,
} from 'api';

import {
  MultiAutocompleteField,
  type MultiAutocompleteFieldProps,
} from '../MultiAutocompleteField/MultiAutocompleteField';

type Props = Omit<
  MultiAutocompleteFieldProps<AssignedAccountManagerListItem>,
  'options' | 'isOptionEqualToValue' | 'getOptionLabel'
> & {
  accountManagerRole?: ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveAmRole;
  tradeCompanyType?: ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveTradeCompanyType;
};

export const MultiAccountManagerAutocompleteField = ({ accountManagerRole, tradeCompanyType, ...rest }: Props) => {
  const { data, isLoading } = useApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve({
    am_role: accountManagerRole,
    trade_company_type: tradeCompanyType,
  });

  return (
    <MultiAutocompleteField<AssignedAccountManagerListItem>
      options={data?.results || []}
      loading={isLoading}
      getOptionLabel={(option) => `${option.short_name} (${option.email})`}
      isOptionEqualToValue={(option, value) => {
        return value === undefined || option?.id?.toString() === (value?.id ?? value)?.toString();
      }}
      {...rest}
    />
  );
};
